export const TYPES = {
  SET_TOGGLE_SIDEBAR: 'SET_TOGGLE_SIDEBAR',
  GET_PRODUCTS: 'GET_PRODUCTS',
  GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
  GET_PRODUCTS_COUNT: 'GET_PRODUCTS_COUNT',
  SET_PRODUCTS_ITEM_TYPE: 'SET_PRODUCTS_ITEM_TYPE',
  SET_PAGIATION_SELECTED_PAGE_INDEX: 'SET_PAGIATION_SELECTED_PAGE_INDEX',
  SET_TOGGLE_BASKET: 'SET_TOGGLE_BASKET_LIST',
  SET_CLOSE_SIDEBAR: 'SET_CLOSE_SIDEBAR',
  GET_ALL_BRANDS: 'GET_ALL_BRANDS',
  GET_ALL_COMPANIES: 'GET_ALL_COMPANIES',
  INCLUDE_SELECTED_BRANDS: 'INCLUDE_SELECTED_BRANDS',
  EXCLUDE_SELECTED_BRANDS: 'EXCLUDE_SELECTED_BRANDS',
  GET_ALL_TAGS: 'GET_ALL_TAGS',
  INCLUDE_SELECTED_TAGS: 'INCLUDE_SELECTED_TAGS',
  EXCLUDE_SELECTED_TAGS: 'EXCLUDE_SELECTED_TAGS',
  GET_PRODUCTS_BY_ITEM_TYPE: 'GET_PRODUCTS_BY_ITEM_TYPE',
  FILTER_BRANDS: 'FILTER_BRANDS',
  FILTER_TAGS: 'FILTER_TAGS',
  SET_SORTING_TYPE: 'SET_SORTING_TYPE',
  SET_BASKET_LIST: 'SET_BASKET_LIST',
  INCREASE_BASKET_ITEM_QUANTITY: 'INCREASE_BASKET_ITEM_QUANTITY',
  SET_BASKET_ITEM_QUANTITY: 'SET_BASKET_ITEM_QUANTITY',
  SET_BASKET_TOTAL_PRICE: 'SET_BASKET_TOTAL_PRICE',
  REMOVE_FROM_BASKET_LIST: 'REMOVE_FROM_BASKET_LIST',
  SET_SELECTED_SORTING_ID: 'SET_SELECTED_SORTING_ID',
  SET_PRODUCTS_LOADING: 'SET_PRODUCTS_LOADING',
};
